<h1 mat-dialog-title>Otkazivanje emitovanja</h1>
<mat-dialog-content>
  <div>
    Da li ste sigurni da zelite da otkažete emitovanje poruke ID=[{{data.id}}], poruka=[{{data.infoMessage}}]?
  </div>
</mat-dialog-content>
<mat-dialog-actions></mat-dialog-actions>
<mat-dialog-actions align="end">
  <button mat-flat-button [disabled]="sending" (click)="closeDialog()">Ne</button>
  <button mat-flat-button color="primary" [disabled]="sending" (click)="confirm()">Da</button>
</mat-dialog-actions>
